<template>
    <b-nav>
        <b-nav-item 
            link-classes="text-dark"
            :to="{ name: 'habilitaUsuarioE24h' }" 
            :class="{ 'active': $route.name === 'habilitaUsuarioE24h' }"
            exact
        >Habilitar Usuário</b-nav-item>
    </b-nav>
</template>

<script>
export default {
    name: 'menu-e24h',
}
</script>

<style scoped>
    .active {
        background-color: #e2e7f5;
        border-radius: 5px;
    }

    .active:hover {
        background-color: #c0cdf1;
    }
</style>